import { Pipe, PipeTransform } from '@angular/core';

import { IArticle } from '../../prisma-xs/models/article.model';

@Pipe({
    name: 'sameWithAsEnclosure',
    standalone: false
})
export class SameWithEnclosurePipe implements PipeTransform {

  transform(article: IArticle, enclosureWidth: number): boolean {
    return article?.widget?.width === enclosureWidth;
  }

}
